import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { MultipleSkeleton } from '../components/common/LoadingSkeleton';
import { Consents } from '../components/PatientProfile/Consents';
import { NavigationBar } from '../components/PatientProfile/NavigationBar';
import { dispatch } from '../rematch';
import { ROUTES } from '../constants/routes.constants';

const PatientConsents = ({
  match: {
    params: { patientId },
  },
}: any) => {
  const history = useHistory();
  const { isLoading } = useSelector(({ patient }: any) => patient);

  useEffect(() => {
    dispatch.patient.fetchPatientData(patientId);
  }, []);

  const navigateBack = () => {
    history.push(ROUTES.PATIENT_ID(patientId));
  };

  return (
    <main>
      <NavigationBar title="Patient Consents" onBackButtonClick={navigateBack} />
      {isLoading ? (
        <MultipleSkeleton />
      ) : (
        <article style={{ padding: '12px', width: 'inherit', backgroundColor: '#e3e3e3' }}>
          <Consents />
        </article>
      )}
    </main>
  );
};

export default PatientConsents;
